/* v8 ignore next */
import type {
    CreateFeedbackRequest,
    CreateFeedbackResponse,
    GetAccessByAppConfigRequest,
    GetAccessByAppConfigResponse,
    GetFeedbackFormConfigRequest,
    GetFeedbackFormConfigResponse,
} from "@amzn/aquila-service-type-script-client";
import {
    AquilaClient,
    CreateFeedbackCommand,
    GetAccessByAppConfigCommand,
    GetFeedbackFormConfigCommand,
} from "@amzn/aquila-service-type-script-client";
import { getCredentialsFromCacheOrCognito } from "@amzn/midway-cognito-type-script-provider";
import type { AwsCredentialIdentity } from "@aws-sdk/types";

import { authStore } from "../../store/auth";
import { APPENV } from "../../utils/app.environment";

export class AquilaApiClient {
    public client: AquilaClient;

    constructor(client: AquilaClient) {
        this.client = client;
    }

    getAccessByAppConfig: (
        request: GetAccessByAppConfigRequest,
    ) => Promise<GetAccessByAppConfigResponse> = async (request) => {
        return this.client.send(new GetAccessByAppConfigCommand(request));
    };

    getFeedbackFormConfig: (
        request: GetFeedbackFormConfigRequest,
    ) => Promise<GetFeedbackFormConfigResponse> = async (request) => {
        return this.client.send(new GetFeedbackFormConfigCommand(request));
    };

    createFeedback: (
        request: CreateFeedbackRequest,
    ) => Promise<CreateFeedbackResponse> = async (request) => {
        return this.client.send(new CreateFeedbackCommand(request));
    };
}

export async function getAquilaApiClient(): Promise<AquilaApiClient> {
    try {
        const {
            settings: { cognitoPoolId, region, aquilaApiEndpoint },
        } = authStore.getState();

        if (!aquilaApiEndpoint) {
            throw new Error("Aquila endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region: aquilaApiEndpoint.getAwsRegion(),
                identityPoolId: cognitoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });

        const client = new AquilaClient({
            endpoint: APPENV.mock_server
                ? "http://localhost:3100"
                : aquilaApiEndpoint.getEndpoint(),
            region,
            credentials: { accessKeyId, secretAccessKey, sessionToken },
        });

        return new AquilaApiClient(client);
    } catch (e: any) {
        throw new Error(e.message);
    }
}

export async function getAquilaApiCredentials(): Promise<AwsCredentialIdentity> {
    try {
        const {
            settings: { cognitoPoolId, aquilaApiEndpoint },
        } = authStore.getState();

        if (!aquilaApiEndpoint) {
            throw new Error("Aquila endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region: aquilaApiEndpoint.getAwsRegion(),
                identityPoolId: cognitoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });

        return { accessKeyId, secretAccessKey, sessionToken };
    } catch (e: any) {
        throw new Error(e.message);
    }
}
